import { Form, FormGroup } from "react-bootstrap";
import { Org } from "../../interfaces/Org";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Overlay } from "../../elements/Overlay";
import { useState } from "react";

export interface OrgEditProps {
    org: Org;
    submitCallback: CallableFunction;
    closeCallback: CallableFunction;
}

export default function OrgEdit(props: OrgEditProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [name, setName] = useState(props.org.name);

    const handleClose = () => {
        props.closeCallback();
    }

    const handleSubmit = () => {
        let error = false;
        let error_messages: string[] = [];
        if (error) {
            alert(error_messages.join('\n'));
        } else {
            const newOrg = Object.assign({}, props.org);
            newOrg.name = name;
            const requestOptionsPost = {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
                body: JSON.stringify(newOrg)
            };
            fetch(import.meta.env.VITE_API_URL + '/v1/org/' + props.org._id, requestOptionsPost)
                .then(response => {
                    if (response.status !== 200) {
                        navigate('/');
                    }
                    return response.json();
                })
                .then(data => {
                    props.submitCallback(newOrg);
                });
        }
    }

    return(
        <Overlay
            title={t("Edit Organization")}
            onClose={handleClose}
            actions={[
                { label: t("Cancel"), variant: "secondary", onClick: handleClose },
                { label: t("Save"), variant: "primary", onClick: handleSubmit }
            ]}
        >
            <div className="admin-edit-org-container">
                <div className="org-form-container">
                    <FormGroup className="name" controlId="name">
                        <Form.Label aria-required={true}>{t("Name")}</Form.Label>
                        <Form.Control
                            type="text"
                            required={true}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder={t("Enter a name")}
                        />
                    </FormGroup>
                </div>
            </div>
        </Overlay>
    );
}